import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoggedInGuard } from '../auth/auth.guards';
import { CampaignsListComponent } from './campaigns-list/campaigns-list.component';
import { CampaignCreateComponent } from './campaign-create/campaign-create.component';
import { CampaignDetailComponent } from './campaign-detail/campaign-detail.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [LoggedInGuard],
    runGuardsAndResolvers: 'always',
    data: {
      sidebar: 'luma',
      title: 'Luma'
    },
    children: [
      { path: '', redirectTo: 'campaigns', pathMatch: 'full' },
      { path: 'campaigns', component: CampaignsListComponent, data: { title: 'Campaigns', permissions: { code: 'luma.campaigns.list' } } },
      { path: 'create', component: CampaignCreateComponent, data: { title: 'Create Campaign', permissions: { code: 'luma.campaigns.create' } } },
      { path: ':id/edit', component: CampaignCreateComponent, data: { title: 'Edit Campaign', permissions: { code: 'luma.campaigns.update' } } },
      { path: ':id', component: CampaignDetailComponent, data: { title: 'Campaign Detail', permissions: { code: 'luma.campaigns.detail' } } },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LumaRoutingModule { }

const lumaModuleLazyLoadRoutes: Routes = [
  {
    path: 'luma',
    loadChildren: () => import('./luma.module').then(m => m.LumaModule),
  },
];

export { lumaModuleLazyLoadRoutes };


